import React from 'react';
import { Navbar } from '../components/Navbar';
import { Hero } from '../components/Hero';
import { Stats } from '../components/Stats';
import { Services } from '../components/Services';
import { SelectedWork } from '../components/SelectedWork';
import { Studio } from '../components/Studio';
import { Process } from '../components/Process';
import { Testimonials } from '../components/Testimonials';
import { Blog } from '../components/Blog';
import { Footer } from '../components/Footer';
import { ScrollToHash } from '../components/ScrollToHash';
export function Home() {
  return <>
      <ScrollToHash data-id="element-488" />
      <div className="glow" data-id="element-489"></div>
      <Navbar data-id="element-490" />
      <main className="wrap" data-id="element-491">
        <Hero data-id="element-492" />
        <Stats data-id="element-493" />
        <Services data-id="element-494" />
        <SelectedWork data-id="element-495" />
        <Studio data-id="element-496" />
        <Process data-id="element-497" />
        <Testimonials data-id="element-498" />
        <Blog data-id="element-499" />
      </main>
      <Footer data-id="element-500" />
    </>;
}